import * as React from 'react';
import { Link } from 'react-router-dom';
import EntitlementIcon from '../../entitlement-icon';
export interface LinkComponentProps {
  link: string;
  id: string;
  displayText: string;
}

const EntitlementLink = (props: LinkComponentProps) => {
  const { link, id, displayText } = props;

  return (
    <Link to={link} onClick={(e) => e.stopPropagation()} className="avatar-container">
      <EntitlementIcon productId={id} className="avatar medium" isCloud />
      {!!displayText && ` ${displayText}`}
    </Link>
  );
};

export default React.memo(EntitlementLink);
